module.exports = __webpack_public_path__ + "img/invoicelist-invoice.e45d9e3c.png";